"use strict";
//https://devforum.wix.com/en/article/wix-style-parameters
Object.defineProperty(exports, "__esModule", { value: true });
var FontTheme;
(function (FontTheme) {
    FontTheme["HEADING_1"] = "Title";
    FontTheme["HEADING_2"] = "Page-title";
    FontTheme["HEADING_3"] = "Heading-XL";
    FontTheme["HEADING_4"] = "Heading-L";
    FontTheme["HEADING_5"] = "Heading-M";
    FontTheme["HEADING_6"] = "Heading-S";
    FontTheme["PARAGRAPH_1"] = "Body-L";
    FontTheme["PARAGRAPH_2"] = "Body-M";
    FontTheme["PARAGRAPH_3"] = "Body-S";
})(FontTheme = exports.FontTheme || (exports.FontTheme = {}));
//# sourceMappingURL=FontTheme.js.map